module.exports = __webpack_public_path__ + "static/img/pdashboard-icon.62134c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdashboard-icon.png
// module id = hgK7
// module chunks = 1